import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=94f7208c"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94f7208c')) {
      api.createRecord('94f7208c', component.options)
    } else {
      api.reload('94f7208c', component.options)
    }
    module.hot.accept("./NewItem.vue?vue&type=template&id=94f7208c", function () {
      api.rerender('94f7208c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/button/NewItem.vue"
export default component.exports